import apiClient from './apiClient';

// Room-type photos — the same rooms.RoomImage rows the public booking
// widget shows on its room cards and View Details popup. Upload goes
// through postForm: the shared axios instance pins
// Content-Type: application/json, which breaks multipart boundaries.
const roomTypeImageService = {
  list: (roomTypeId) => apiClient.get(`/v1/room-types/${roomTypeId}/images`),
  upload: (roomTypeId, files) => {
    const fd = new FormData();
    Array.from(files).forEach((f) => fd.append('image', f));
    return apiClient.postForm(`/v1/room-types/${roomTypeId}/images`, fd);
  },
  setCover: (roomTypeId, imageId) =>
    apiClient.patch(`/v1/room-types/${roomTypeId}/images/${imageId}`, { isPrimary: true }),
  remove: (roomTypeId, imageId) =>
    apiClient.del(`/v1/room-types/${roomTypeId}/images/${imageId}`),
};

export default roomTypeImageService;
